import { connect } from 'react-redux';
import Comparable from './Comparable';
import { getComparableDetails } from 'actions/comparable/';

const mapStateToProps = (state) => {
  return {
    isFetching: state.comparable.fetchingComparableDetails,
    details: state.comparable.comparableDetails
  };
};

const mapDispatchToProps = (dispatch) => ({
  getComparableDetails(token) {
    dispatch(getComparableDetails(token));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Comparable);
